/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/pinGenerators.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    PIN generation utilities for Conferences module.
────────────────────────────────────────────────────────────────*/

/**
 * Generates a random 4-digit PIN (1000-9999)
 */
export function generateRandomPin(): string {
  const digits = Math.floor(Math.random() * 9000) + 1000;
  return digits.toString();
}

